import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Columns = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Columns' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M17,2 L17,22 L17,2 Z M12,2 L12,22 L12,2 Z M7,2 L7,22 L7,2 Z M2,22 L22,22 L22,2 L2,2 L2,22 Z' />
  </StyledIcon>
);
